import styled from "styled-components";
const Info = styled.div`
  display: flex;
  justify-content: center;
  color: white;
  width: 100%;
  height: 40vh;
  overflow: hidden;
  background-color: #333d1d;
  overflow-x: hidden;
`;
const Pole = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  height: 100%;
  background-color: #5b2632;
  flex-direction: column;
  overflow-x: hidden;

  & > h1 {
    font-size: 8vh;
  }
  & > p {
    font-size: 2rem;
  }
  @media screen and (max-width: 479px) {
    & > h1 {
      font-size: 3.4rem;
    }
    & > p {
      font-size: 1.6rem;
    }
  }
`;
export default function Discord() {
  return (
    <Info>
      <Pole>
        <h1>Discord</h1>
        <p>Phishe#6275</p>
      </Pole>
    </Info>
  );
}
function Email() {
  return (
    <Info>
      <Pole>
        <h1>Mój Email</h1>
        <p>szootnikus@gmail.com</p>
      </Pole>
    </Info>
  );
}

function Telefon() {
  return (
    <Info>
      <Pole>
        <h1>Telefon</h1>
        <p>(+48) 536 856 212</p>
      </Pole>
    </Info>
  );
}

export { Discord, Email, Telefon };
